import React from 'react';
import {
  PropertyPortal,
  type CatalogProperty,
  type PropertyPortalPublication,
} from 'src/api/generated';
import type { getSupportedMeliOperationFromPublication } from '../../utils/meli-publication.util';
import { getPropertyPublicationStatusDisplay } from '../../utils/property-publication-display.util';
import { PropertyPublicationInfoBadge } from '../molecules/property-publication-info-badge';
import { PropertyMeliPublishingModal } from '../molecules/property-meli-publishing-modal';
import { PropertyMeliPublishingManager } from './property-meli-publishing-manager';

interface PropertyPublicationsManagedModalProps {
  managedPublication: PropertyPortalPublication | null;
  managedProperty: CatalogProperty | null;
  managedOperation: ReturnType<typeof getSupportedMeliOperationFromPublication>;
  managedPropertyPublications: PropertyPortalPublication[];
  publications: PropertyPortalPublication[];
  isMeliSyncMode: boolean;
  onClose: () => void;
  refetchManagedPropertyPublications: () => Promise<unknown>;
  refetch: () => Promise<unknown>;
}

export const PropertyPublicationsManagedModal: React.FC<
  PropertyPublicationsManagedModalProps
> = ({
  managedPublication,
  managedProperty,
  managedOperation,
  managedPropertyPublications,
  publications,
  isMeliSyncMode,
  onClose,
  refetchManagedPropertyPublications,
  refetch,
}) => {
  if (
    !managedPublication ||
    !managedProperty ||
    managedPublication.portal !== PropertyPortal.MELI ||
    !managedOperation
  ) {
    return null;
  }

  return (
    <PropertyMeliPublishingModal
      isOpen
      onClose={onClose}
      operation={managedOperation}
      headerStatus={
        <PropertyPublicationInfoBadge
          display={getPropertyPublicationStatusDisplay({
            publication: managedPublication,
          })}
        />
      }
      body={
        <PropertyMeliPublishingManager
          property={managedProperty}
          selectedOperation={managedOperation}
          selectedPublicationId={managedPublication.id}
          publications={
            managedPropertyPublications.length > 0
              ? managedPropertyPublications
              : publications.filter(
                  (publication) =>
                    publication.propertyId === managedProperty.id &&
                    publication.portal === managedPublication.portal
                )
          }
          refetchPublications={async () => {
            await Promise.all([
              refetchManagedPropertyPublications(),
              refetch(),
            ]);
          }}
          setQueuedAction={() => undefined}
          isSyncMode={isMeliSyncMode}
          showHeader={false}
        />
      }
    />
  );
};
